import stampDutyreportQuery from './view/stampDutyreportQuery.html'

export default {
  base: {
    state: 'declaration.stampDuty.stampDutyreportQuery',
    config: {
      url: '/stampDutyreportQuery',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.stampDuty.stampDutyreportQuery.list',
      title: '申报报表查询',
    },
  },
  list: {
    state: 'declaration.stampDuty.stampDutyreportQuery.list',
    config: {
      url: '/list',
      template: stampDutyreportQuery,
      controller: 'stampDutyreportQueryCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/stampDuty/stampDutyreportQuery/routers.js